// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"partners_m-1480__2anuc","container":"partners_container__iA8re","bg1":"partners_bg1___fHRt","row":"partners_row__xRlUu"};